import {STORE_CONTENT_EXPORTS} from '../constants'

export function storeContentExport(apiResponse) {
  return {type: STORE_CONTENT_EXPORTS, contentExports: [apiResponse]}
}

export function storeContentExports(apiResponse) {
  return {type: STORE_CONTENT_EXPORTS, contentExports: apiResponse}
}
